const getImageResizeUrl = (url: any, width: any, height: any, scaleBySmallerSide = true) =>
  `${url}?height=${height}&amp;width=${width}&amp;scaleBySmallerSide=${scaleBySmallerSide}`;

export default getImageResizeUrl;
